<template>
  <div class="robbing">
    <nav class="robbing-nav">
      <div class="robbing-nav-item" :class="{'select':orderType=='time'}" @click="toggleType('time')">按时间</div>
      <div class="robbing-nav-item" :class="{'select':orderType=='fee'}" @click="toggleType('fee')">按赏金</div>
      <div class="robbing-nav-item" @click="gotoRobbinged">已接单</div>
      <div class="robbing-nav-item" @click="setBuildingManger" v-if="userInfo.isPaotuiLeader">设置楼长</div>
    </nav>
    <div class="empty-data" v-if="!haveData">
      <div>
        <i class="iconfont icon-similarproduct"></i>
      </div>
      <div>
        <p>暂无可接订单</p>
      </div>
    </div>
    <section class="robbing-order" v-for="item in paotuiOrders" :key="item._id">
      <figure class="robbing-order-item">
        <div class="order-item-top">
          <div class="item-top-left">
            <span>{{item.typeStr}}</span>
          </div>
          <div class="item-top-right">接单截止时间：还有{{item.timeLeft}}</div>
        </div>

        <div class="weui-cells weui-cells_form" style="margin-top: 0px;">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <p>跑腿单号</p>
            </div>
            <div class="weui-cell__ft" style="font-size: 100%;">{{item.orderNo}}</div>
          </div>
          <div class="weui-cell" v-if="item.type == 1">
            <div class="weui-cell__bd">
              <p>{{item.expressCompanyName}}</p>
            </div>
            <div class="weui-cell__ft" style="font-size: 100%;">{{item.expressNo}}</div>
          </div>
          <div class="weui-cell" v-if="item.expressTakein">
            <div class="weui-cell__bd">
              <p>待寄物品</p>
            </div>
            <div class="weui-cell__ft" style="font-size: 100%;">{{item.expressTakein.goodsName}}
              x{{item.expressTakein.goodsCount?item.expressTakein.goodsCount:1}}</div>
          </div>
        </div>
        <div class="robbing-order-add">
          <div class="order-add-start" style="flex: 3;">
            <div>
              <i class="iconfont icon-map" aria-hidden="true" style="font-weight: bold"></i>
            </div>
            <div style="padding: 4px;">{{item.startPoint}}</div>
          </div>
          <div class="order-add-to" style="border-left: 1px solid #eee; border-right: 1px solid #eee; color: #1aad19;">
            <i class="iconfont icon-jiantou2" aria-hidden="true" style="font-size: 32px;"></i>
          </div>
          <div class="order-add-end" style="flex: 3;">
            <div>
              <i class="iconfont icon-map" aria-hidden="true" style="font-weight: bold"></i>
            </div>
            <div style="padding: 4px;">{{item.endPoint}}</div>
          </div>
        </div>

        <div class="robbing-order-msg">
          <div class="order-msg-item" style="flex: 1">
            <i class="iconfont icon-account"></i> {{item.proxyReceiver?item.proxyReceiver:item.initiator}}
            <a :href="'tel:'+(item.proxyReceiverPhone||item.initiatorPhone)" style="color: blue;">
              <i class="iconfont icon-mobilephone"></i>
            </a>
          </div>
          <div class="order-msg-item" style="flex: 1">
            <i class="iconfont icon-daxiao" aria-hidden="true"></i>
            {{item.goodsType==1?"小件":""}}{{item.goodsType==2?"中件":""}}{{item.goodsType==3?"大件":""}}{{item.goodsName?item.goodsName:""}}
          </div>
          <div class="order-msg-item" style="flex: 1">
            <i class="iconfont icon-rmb" aria-hidden="true"></i> {{item.payFee/100}}元
          </div>
        </div>

        <div class="robbing-order-remark">
          <div class="order-remark-left" align="center">描述</div>
          <div class="order-remark-center"
            :class="{marginRight60:item.status==0||item.status==1||item.status==2||item.status==3}">
            <div class="order-item-time" style="font-size: 14px;">
              <!-- <p style="font-weight: bold; color: red;">跑腿性别要求： {{item.sexLimitStr}}</p> -->
              <p>时间：
                <span style="color: orangered; font-weight: bold;">{{item.serviceTime}}前</span>
              </p>
              <p>备注： {{item.remark?item.remark:'无'}}
              </p>
            </div>
          </div>
        </div>

        <a href="javascript:;" class="robbing-order-get clickable"
          v-if="userInfo.authStatus==1&&userInfo.paotuiStatus==1" @click="robbing(item)">接 单</a>
        <a href="javascript:;" class="robbing-order-get disable"
          v-if="userInfo.authStatus!=1||userInfo.paotuiStatus!=1">
          <i class="iconfont icon-password"></i> 接 单
        </a>

      </figure>

    </section>

    <div class="weui-footer" v-if="!haveData">
      <p class="weui-footer__links">
        <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
      </p>
      <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
    </div>
  </div>
</template>
<script>
import config from "../config/config.js";
import weui from "weui.js";
import axios from "axios";
import moment from "moment";
import io from "socket.io-client";

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      haveData: true,
      userInfo: {
        isPaotuiLeader: false
      },
      year: moment().format("YYYY"),
      orderType: "time",
      paotuiOrders: [],
      paotuiAble: false,
      paotuiApplyAble: false
    };
  },
  created() {
    let loading = weui.loading("数据加载中", {
      className: "custom-classname"
    });

    let that = this;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        this.userInfo = response.data.data;
        if (this.userInfo.paotuiStatus == 1) {
          this.paotuiAble = this.userInfo.worksite.paotuiAble;
          this.paotuiApplyAble = this.userInfo.worksite.paotuiApplyAble;

          // 查找本网点的跑腿订单列表，后台需要增加性别过滤
          axios
            .get(
              "/api/paotuiOrder/toRobbing/" +
              this.userInfo.worksite._id +
              "/" +
              this.orderType
            )
            .then(res => {
              loading.hide(function () { });
              if (res.data.success) {
                this.paotuiOrders = res.data.data;
                if (this.paotuiOrders.length == 0) {
                  this.haveData = false;
                }
                for (let i = 0; i < this.paotuiOrders.length; i++) {
                  // 跑腿性别要求
                  if (
                    !this.paotuiOrders[i].sexLimit ||
                    this.paotuiOrders[i].sexLimit == -1
                  ) {
                    this.paotuiOrders[i].sexLimitStr = "不限";
                  } else if (this.paotuiOrders[i].sexLimit == 1) {
                    this.paotuiOrders[i].sexLimitStr = "男";
                  }
                  if (this.paotuiOrders[i].sexLimit == 2) {
                    this.paotuiOrders[i].sexLimitStr = "女";
                  }

                  let du = moment.duration(
                    moment(this.paotuiOrders[i].requireArriveTime) - moment(),
                    "ms"
                  );
                  this.paotuiOrders[i].timeLeft = du.locale("zh-cn").humanize();
                  if (this.paotuiOrders[i].type == 1) {
                    this.paotuiOrders[i].typeStr = "送件上门";
                  } else if (this.paotuiOrders[i].type == 2) {
                    this.paotuiOrders[i].typeStr = "上门取件";
                  } else if (this.paotuiOrders[i].type == 3) {
                    this.paotuiOrders[i].typeStr = "餐饮服务";
                  } else if (this.paotuiOrders[i].type == 4) {
                    this.paotuiOrders[i].typeStr = "其他服务";
                  }

                  let toDayStr = moment().format("YYYY-MM-DD");
                  let nextDayStr = moment()
                    .add(1, "days")
                    .format("YYYY-MM-DD");
                  let next2DayStr = moment()
                    .add(2, "days")
                    .format("YYYY-MM-DD");
                  let doorServiceDayStr = moment(
                    this.paotuiOrders[i].requireArriveTime
                  ).format("YYYY-MM-DD");
                  if (doorServiceDayStr == toDayStr) {
                    this.paotuiOrders[i].serviceTime =
                      "今天 " +
                      moment(this.paotuiOrders[i].requireArriveTime).format(
                        "HH点:mm分"
                      );
                  } else if (doorServiceDayStr == nextDayStr) {
                    this.paotuiOrders[i].serviceTime =
                      "明天 " +
                      moment(this.paotuiOrders[i].requireArriveTime).format(
                        "HH点:mm分"
                      );
                  } else if (doorServiceDayStr == next2DayStr) {
                    this.paotuiOrders[i].serviceTime =
                      "后天 " +
                      moment(this.paotuiOrders[i].requireArriveTime).format(
                        "HH点:mm分"
                      );
                  } else {
                    this.paotuiOrders[i].serviceTime = moment(
                      this.paotuiOrders[i].requireArriveTime
                    ).format("YYYY年MM月DD日 HH点:mm分");
                  }
                }
                const socket = io(config.socket, {
                  transports: ["websocket"]
                });
                // 建立 socket 连接
                socket.on("connect", function () {
                  console.log("socket.io connect...");
                });
                socket.on("reconnect_attempt", () => {
                  socket.io.opts.transports = ["websocket", "polling"];
                });
                socket.on(
                  that.userInfo.worksite._id + "-paotuiOrderAdd",
                  function (data) {
                    // 如果当前新的跑腿单对性别有要求，则只有对应性别的跑腿才能看到
                    let currUserSex = that.userInfo.sex;
                    if (data.sexLimit == -1 || data.sexLimit == currUserSex) {
                      // 对数据进行二次处理
                      // 跑腿性别要求
                      if (data.sexLimit == -1) {
                        data.sexLimitStr = "不限";
                      } else if (data.sexLimit == 1) {
                        data.sexLimitStr = "男";
                      }
                      if (data.sexLimit == 2) {
                        data.sexLimitStr = "女";
                      }

                      // 剩余时间
                      let du = moment.duration(
                        moment(data.requireArriveTime) - moment(),
                        "ms"
                      );
                      data.timeLeft = du.locale("zh-cn").humanize();

                      // 状态
                      if (data.type == 1) {
                        data.typeStr = "送件上门";
                      } else if (data.type == 2) {
                        data.typeStr = "上门取件";
                      } else if (data.type == 3) {
                        data.typeStr = "餐饮服务";
                      } else if (data.type == 4) {
                        data.typeStr = "其他服务";
                      }

                      let toDayStr = moment().format("YYYY-MM-DD");
                      let nextDayStr = moment()
                        .add(1, "days")
                        .format("YYYY-MM-DD");
                      let next2DayStr = moment()
                        .add(2, "days")
                        .format("YYYY-MM-DD");
                      let doorServiceDayStr = moment(
                        data.requireArriveTime
                      ).format("YYYY-MM-DD");
                      if (doorServiceDayStr == toDayStr) {
                        data.serviceTime =
                          "今天 " +
                          moment(data.requireArriveTime).format("HH点:mm分");
                      } else if (doorServiceDayStr == nextDayStr) {
                        data.serviceTime =
                          "明天 " +
                          moment(data.requireArriveTime).format("HH点:mm分");
                      } else if (doorServiceDayStr == next2DayStr) {
                        data.serviceTime =
                          "后天 " +
                          moment(data.requireArriveTime).format("HH点:mm分");
                      } else {
                        data.serviceTime = moment(
                          data.requireArriveTime
                        ).format("YYYY年MM月DD日 HH点:mm分");
                      }

                      that.paotuiOrders.unshift(data);
                      that.haveData = true;
                    }
                  }
                );

                // 上门取件跑腿特殊处理
                if (that.userInfo.pickupAble) {
                  socket.on(
                    that.userInfo.worksite._id + "-paotuiPickupOrderAdd",
                    function (data) {
                      // 如果当前新的跑腿单对性别有要求，则只有对应性别的跑腿才能看到
                      let currUserSex = that.userInfo.sex;
                      if (data.sexLimit == -1 || data.sexLimit == currUserSex) {
                        // 对数据进行二次处理
                        // 跑腿性别要求
                        if (data.sexLimit == -1) {
                          data.sexLimitStr = "不限";
                        } else if (data.sexLimit == 1) {
                          data.sexLimitStr = "男";
                        }
                        if (data.sexLimit == 2) {
                          data.sexLimitStr = "女";
                        }

                        // 剩余时间
                        let du = moment.duration(
                          moment(data.requireArriveTime) - moment(),
                          "ms"
                        );
                        data.timeLeft = du.locale("zh-cn").humanize();

                        // 状态
                        if (data.type == 1) {
                          data.typeStr = "送件上门";
                        } else if (data.type == 2) {
                          data.typeStr = "上门取件";
                        } else if (data.type == 3) {
                          data.typeStr = "餐饮服务";
                        } else if (data.type == 4) {
                          data.typeStr = "其他服务";
                        }

                        let toDayStr = moment().format("YYYY-MM-DD");
                        let nextDayStr = moment()
                          .add(1, "days")
                          .format("YYYY-MM-DD");
                        let next2DayStr = moment()
                          .add(2, "days")
                          .format("YYYY-MM-DD");
                        let doorServiceDayStr = moment(
                          data.requireArriveTime
                        ).format("YYYY-MM-DD");
                        if (doorServiceDayStr == toDayStr) {
                          data.serviceTime =
                            "今天 " +
                            moment(data.requireArriveTime).format("HH点:mm分");
                        } else if (doorServiceDayStr == nextDayStr) {
                          data.serviceTime =
                            "明天 " +
                            moment(data.requireArriveTime).format("HH点:mm分");
                        } else if (doorServiceDayStr == next2DayStr) {
                          data.serviceTime =
                            "后天 " +
                            moment(data.requireArriveTime).format("HH点:mm分");
                        } else {
                          data.serviceTime = moment(
                            data.requireArriveTime
                          ).format("YYYY年MM月DD日 HH点:mm分");
                        }

                        that.paotuiOrders.unshift(data);
                        that.haveData = true;
                      }
                    }
                  );
                }

                socket.on("paotuiOrderCancel", function (_id) {
                  for (let i = 0; i < that.paotuiOrders.length; i++) {
                    if (_id == that.paotuiOrders[i]._id) {
                      that.paotuiOrders.splice(i, 1);
                    }
                  }
                  if (that.paotuiOrders.length == 0) {
                    that.haveData = false;
                  }
                });
                socket.on("paotuiOrderRobbinged", function (item) {
                  for (let i = 0; i < that.paotuiOrders.length; i++) {
                    if (item._id == that.paotuiOrders[i]._id) {
                      that.paotuiOrders.splice(i, 1);
                    }
                  }
                  if (that.paotuiOrders.length == 0) {
                    that.haveData = false;
                  }
                });
              } else {
                this.haveData = false;
                loading.hide(function () { });
                weui.topTips("获取待接单数据出错", 2000);
              }
            })
            .catch(err => {
              this.haveData = false;
              loading.hide(function () { });
              weui.topTips("获取待接单数据出错", 2000);
            });
        } else {
          loading.hide(function () { });
          // 跳转到跑腿申请页面
          this.$router.push("/paotuiApply/" + this.encodeToken);
        }
      })
      .catch(error => {
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    toggleType(type) {
      if (this.orderType != type) {
        this.orderType = type;
        // 重新查询待接单数据
        let loading = weui.loading("数据加载中", {
          className: "custom-classname"
        });

        axios
          .get(
            "/api/paotuiOrder/toRobbing/" +
            this.userInfo.worksite._id +
            "/" +
            this.orderType
          )
          .then(res => {
            loading.hide(function () { });
            if (res.data.success) {
              this.paotuiOrders = res.data.data;
              if (this.paotuiOrders.length == 0) {
                this.haveData = false;
              } else {
                this.haveData = true;
              }
              for (let i = 0; i < this.paotuiOrders.length; i++) {
                // 跑腿性别要求
                if (
                  !this.paotuiOrders[i].sexLimit ||
                  this.paotuiOrders[i].sexLimit == -1
                ) {
                  this.paotuiOrders[i].sexLimitStr = "不限";
                } else if (this.paotuiOrders[i].sexLimit == 1) {
                  this.paotuiOrders[i].sexLimitStr = "男";
                }
                if (this.paotuiOrders[i].sexLimit == 2) {
                  this.paotuiOrders[i].sexLimitStr = "女";
                }

                let du = moment.duration(
                  moment(this.paotuiOrders[i].requireArriveTime) - moment(),
                  "ms"
                );
                this.paotuiOrders[i].timeLeft = du.locale("zh-cn").humanize();
                if (this.paotuiOrders[i].type == 1) {
                  this.paotuiOrders[i].typeStr = "送件上门";
                } else if (this.paotuiOrders[i].type == 2) {
                  this.paotuiOrders[i].typeStr = "上门取件";
                } else if (this.paotuiOrders[i].type == 3) {
                  this.paotuiOrders[i].typeStr = "餐饮服务";
                } else if (this.paotuiOrders[i].type == 4) {
                  this.paotuiOrders[i].typeStr = "其他服务";
                }

                let toDayStr = moment().format("YYYY-MM-DD");
                let nextDayStr = moment()
                  .add(1, "days")
                  .format("YYYY-MM-DD");
                let next2DayStr = moment()
                  .add(2, "days")
                  .format("YYYY-MM-DD");
                let doorServiceDayStr = moment(
                  this.paotuiOrders[i].requireArriveTime
                ).format("YYYY-MM-DD");
                if (doorServiceDayStr == toDayStr) {
                  this.paotuiOrders[i].serviceTime =
                    "今天 " +
                    moment(this.paotuiOrders[i].requireArriveTime).format(
                      "HH点:mm分"
                    );
                } else if (doorServiceDayStr == nextDayStr) {
                  this.paotuiOrders[i].serviceTime =
                    "明天 " +
                    moment(this.paotuiOrders[i].requireArriveTime).format(
                      "HH点:mm分"
                    );
                } else if (doorServiceDayStr == next2DayStr) {
                  this.paotuiOrders[i].serviceTime =
                    "后天 " +
                    moment(this.paotuiOrders[i].requireArriveTime).format(
                      "HH点:mm分"
                    );
                } else {
                  this.paotuiOrders[i].serviceTime = moment(
                    this.paotuiOrders[i].requireArriveTime
                  ).format("YYYY年MM月DD日 HH点:mm分");
                }
              }
            } else {
              this.haveData = false;
              loading.hide(function () { });
              weui.topTips("获取待接单数据出错", 2000);
            }
          })
          .catch(err => {
            this.haveData = false;
            loading.hide(function () { });
            weui.topTips("获取待接单数据出错", 2000);
          });
      }
    },
    gotoRobbinged() {
      this.$router.push("/robbingList/2/ing/" + this.encodeToken);
    },
    setBuildingManger() {
      this.$router.push("/setBuildingManager/" + this.encodeToken);
    },
    robbing(item) {
      if (item.sexLimit != -1 && this.userInfo.sex != item.sexLimit) {
        if (item.sexLimit == 1) {
          weui.alert("对不起，该跑腿单只有男生可接。");
          return;
        } else if (item.sexLimit == 2) {
          weui.alert("对不起，该跑腿单只有女生可接。");
          return;
        }
      } else {
        weui.confirm(
          "该单还有 " + item.timeLeft + ",确定接单？",
          function () {
            axios
              .put("/api/paotuiOrder/robbingRollModule/" + item.orderNo)
              .then(res => {
                if (res.data.success) {
                  weui.toast("接单成功", 1000);
                } else {
                  setTimeout(function () {
                    weui.alert(res.data.message);
                  }, 1000);
                }
              })
              .catch(err => {
                console.log(err);
                weui.alert('接单失败');
              });
          },
          function () { }
        );
      }
    }
  }
};
</script>
<style scoped>
.robbing {
  font-size: 14px;
  margin: 0 auto;
}

.robbing-nav {
  display: flex;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  text-align: center;
}

.robbing-nav-item {
  flex: 1;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
  text-align: center;
}

.robbing-nav-item:last-child {
  border-right: none;
}

.robbing-nav-item.select {
  color: red;
  border-bottom: 1px solid red;
}

.robbing-title {
  height: 60px;
  line-height: 60px;
  background-color: rgb(36, 36, 36);
  display: flex;
  margin-top: 10px;
}

.robbing-title-left {
  width: 60px;
  height: 60px;
}

.robbing-title-left img {
  padding: 0px;
  width: 58px;
  height: 58px;
  object-fit: cover;
}

.robbing-title-center {
  flex: 1;
  background-color: #1aad19;
  color: white;
  text-align: left;
  padding-left: 20px;
  font-size: 16px;
  letter-spacing: 2px;
}

.robbing-title-center span {
  font-weight: bold;
}

.robbing-title-center .small-tip {
  font-size: 8px;
}

.robbing-title-center p:first-child {
  height: 32px;
  line-height: 32px;
}

.robbing-title-center p:last-child {
  height: 26px;
  line-height: 1em;
}

.robbing-title-right {
  width: 100px;
}

.robbing-go {
  width: 80px;
  height: 20px;
  line-height: 20px;
  display: inline-block;
  color: white;
  background-color: #1aad19;
  border-radius: 5px;
  font-size: 12px;
}

.robbing-progress {
  display: flex;
  height: 70px;
  line-height: 70px;
  border-bottom: 1px solid #eee;
  color: grey;
}

.robbing-progress-item {
  flex: 1;
  text-align: center;
}

.robbing-progress-item.clickable {
  color: orangered;
}

.robbing-progress-item.done {
  color: #1aad19;
}

.robbing-progress-item.verifying {
  color: deepskyblue;
}

.progress-item-top {
  line-height: 1em;
  font-size: 32px;
  padding-top: 8px;
}

.progress-item-top i {
  font-size: 30px;
}

.progress-item-bottom {
  line-height: 1em;
}

.robbing .icon-daxiao-,
.order-add-to {
  font-size: 34px;
}

.robbing-order-item {
  position: relative;
  margin-left: 10px;
  margin-right: 10px;
}

.order-item-top {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #eee;
  border-top: #1aad19 3px solid;
}

.item-top-left {
  position: absolute;
  left: 10px;
  top: 0px;
  padding-top: 2px;
}

.item-top-left span {
  padding: 3px 5px;
  color: white;
  background-color: orange;
  border-radius: 3px;
  font-size: 12px;
}

.item-top-right {
  position: absolute;
  right: 10px;
  top: 0px;
  font-size: 14px;
  padding-top: 2px;
}

.robbing-order-add {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  text-align: center;
}

.order-add-start {
  white-space: normal;
  word-break: break-all;
  width: 120px;
  position: relative;
}

.order-add-start:before {
  content: "";
  position: absolute;
  right: 0px;
  top: -60px;
  border-left: 1px solid #eee;
  width: 1px;
}

.order-add-start i {
  color: rgb(37, 155, 36);
  font-size: 23px;
  position: relative;
  top: 3px;
}

.order-add-end {
  padding-right: 5px;
  width: 120px;
  position: relative;
}

.order-add-end:before {
  content: "";
  position: absolute;
  left: 0px;
  top: -60px;
  border-left: 1px solid #eee;
  width: 1px;
}

.order-add-end i {
  color: rgb(212, 54, 29);
  font-size: 23px;
  position: relative;
  top: 3px;
}

.order-add-to {
  flex: 1;
}

.robbing-order-msg {
  display: flex;
  align-items: center;
  height: 40px;
  border-bottom: 1px solid #eee;
  text-align: center;
}

.order-msg-item {
  flex: 1;
}

.robbing-order-remark {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  overflow: hidden;
  padding: 5px;
}

.order-remark-left {
  width: 60px;
  position: absolute;
  left: 0;
  right: 0;
}

.order-remark-left:before {
  content: "";
  position: absolute;
  right: 0px;
  top: -70px;
  width: 1px;
}

.order-remark-center {
  text-align: left;
  border-left: 1px solid #eee;
  margin-left: 56px;
  padding-left: 10px;
}

.order-remark-right {
  text-align: left;
  border-left: 1px solid #eee;
  padding-left: 10px;
}

.robbing-order-get {
  display: block;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: white;
  font-size: 16px;
}

.robbing-order-get.clickable {
  background-color: #1aad19;
}

.robbing-order-get.disable {
  background-color: grey;
}

.robbing-order-item {
  margin-top: 10px;
}

.robbing-order-push {
  display: block;
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  line-height: 18px;
  font-size: 15px;
  color: white;
  border-radius: 100%;
  background-color: rgb(37, 155, 36);
}

.robbing-order-push span {
  display: inline-block;
  margin-top: 12px;
}

.empty-data {
  text-align: center;
  margin-top: 30px;
}

.empty-data div i {
  font-size: 120px;
  color: #cccccc;
}

.empty-data div p {
  font-size: 30px;
  color: #cccccc;
}

.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.paotui-order-no {
  flex: 1;
  text-align: left;
  margin-left: 10px;
  font-size: 18px;
}

.paotui-tips {
  text-align: left;
  padding: 10px;
  padding-left: 15px;
  background-color: lightyellow;
}
</style>


// WEBPACK FOOTER //
// src/components/Robbing.vue